import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Field, useFormikContext } from "formik";
import classnames from "classnames";
import {
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fontAwesome from "@fortawesome/free-solid-svg-icons";

const PasswordField = (props) => {
  const [focusedField, setFocusedField] = useState(false);
  
  const { isSubmitting } = useFormikContext();

  return (
    <FormGroup
      className={classnames({
        focused: focusedField,
      })}
    >
      <InputGroup className="input-group-merge input-group-alternative">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            {props.fontAwesome ? (
              <FontAwesomeIcon icon={props.fontAwesome[fontAwesome]} />
            ) : (
              <i className={props.icon} />
            )}
          </InputGroupText>
        </InputGroupAddon>
        <FormattedMessage id={"fields." + props.name}>
          {(placeholder) => (
            <Field
              name={props.name}
              type="password"
              className="form-control"
              placeholder={placeholder}
              onFocus={() => setFocusedField(true)}
              onBlur={(e) => {
                props.handleBlur(e);
                setFocusedField(false);
              }}
              disabled={isSubmitting}
            />
          )}
        </FormattedMessage>
      </InputGroup>
    </FormGroup>
  );
};

PasswordField.defaultProps = {
  name: "password",
  fontAwesome: "",
  icon: "ni ni-lock-circle-open",
};

export { PasswordField };
